export const errors = {
    required: 'Zip code required',
    minLength: 'Please enter a 5 digit zip code',
    maxLength: 'That\'s too long, please enter a 5 digit zip code',
    invalid: 'Please enter a 5 digit zip code'
};
